
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Emergency_Contraception_Pills_Dosage_and_Protocol",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Emergency_Contraception_Pills_Dosage_and_Protocol.vue